export const isStatusSuccess = (status: number) =>
  Math.floor(status / 100) === 2;
